import { put, takeEvery } from 'redux-saga/effects';
import { checkActiveProfile } from '../../actions/CheckActiveProfile';
import {
  setActiveProfile,
  unsetActiveProfile,
} from '../../actions/ProfileList';

function* checkActiveProfileSaga(action) {
  console.log(action)
  try {
    let response =
      localStorage.activeProfile &&
      JSON.parse(localStorage.getItem('activeProfile'));
    if (response !== null) {
      response = { ...response, redirect: false };
      yield put(setActiveProfile(response));
    } else {
      yield put(unsetActiveProfile());
    }
  } catch (err) {
    //    ignore
  }
}

export function* activeProfileWatcher() {
  yield takeEvery(checkActiveProfile.toString(), checkActiveProfileSaga);
}
